import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 8px 0 32px;
  background: linear-gradient(180deg, #f6f8ff 0%, #f9fbff 40%, #ffffff 100%);
  min-height: 100%;
`;

export const Loader = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const PageTitle = styled.h2`
  color: #0b1d5d;
  font-size: 28px;
  font-weight: 800;
  margin: 0;
`;

export const Subtitle = styled.p`
  color: #4c5f8f;
  font-size: 15px;
  font-weight: 500;
  margin: 6px 0 0;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;

  /* Estilização do DatePicker */
  .MuiOutlinedInput-root {
    background: white;
    border-radius: 12px;
    font-weight: 700;
    color: #0b1d5d;
    border: 1px solid #e1e6f5;
    transition: all 0.2s ease;

    &:hover {
      border-color: #0b5fff;
      box-shadow: 0 4px 12px rgba(11, 95, 255, 0.08);
    }

    &.Mui-focused {
      border-color: #0b5fff;
      box-shadow: 0 8px 18px rgba(11, 95, 255, 0.18);
    }

    fieldset {
      border: none;
    }

    input {
      padding: 10px 14px;
      font-size: 14px;
      font-weight: 700;
      color: #0b1d5d;
      text-transform: capitalize;
    }
  }

  .MuiSvgIcon-root {
    color: #0b5fff;
  }
`;

export const QuickButton = styled.button<{ $active?: boolean }>`
  border: 1px solid ${(props) => (props.$active ? "#0b5fff" : "#e1e6f5")};
  background: ${(props) =>
    props.$active ? "rgba(11,95,255,0.12)" : "white"};
  color: ${(props) => (props.$active ? "#0b1d5d" : "#42507a")};
  padding: 10px 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.$active ? "0 8px 18px rgba(11,95,255,0.18)" : "none"};

  &:hover {
    border-color: #0b5fff;
    color: #0b1d5d;
    transform: translateY(-1px);
  }
`;

export const IdentityCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  background: linear-gradient(135deg, #eef2ff 0%, #f9fbff 50%, #ffffff 100%);
  border: 1px solid #e6e9f5;
  border-radius: 16px;
  box-shadow: 0 14px 38px rgba(11, 29, 93, 0.08);
  flex-wrap: wrap;
`;

export const IdentityLabel = styled.p`
  margin: 0;
  color: #4c5f8f;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const IdentityName = styled.p`
  margin: 4px 0 0;
  color: #0b1d5d;
  font-size: 22px;
  font-weight: 800;
`;

export const IdentityDate = styled.p`
  margin: 6px 0 0;
  color: #62719a;
  font-size: 13px;
`;

export const RatingPill = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: white;
  border: 1px solid #ffe9a8;
  border-radius: 12px;
  color: #c48c00;
  font-weight: 800;
  box-shadow: 0 10px 24px rgba(255, 204, 0, 0.12);
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: #0b1d5d;
  font-size: 18px;
  font-weight: 800;
`;

export const MetricsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;

  & > * {
    flex: 1 1 220px;
    min-width: 200px;
    max-width: 260px;
  }

  @media (max-width: 1024px) {
    /* Tablets: pelo menos 2 por linha */
    & > * {
      flex: 1 1 45%;
      min-width: 200px;
      max-width: 280px;
    }
  }

  @media (max-width: 640px) {
    /* Mobile: 1 por linha */
    & > * {
      flex: 1 1 100%;
      min-width: 0;
      max-width: 100%;
    }
  }
`;

export const MetricCard = styled.div`
  background: white;
  border: 1px solid #e6e9f5;
  border-radius: 14px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 12px 28px rgba(11, 29, 93, 0.06);
  min-height: 160px;
  position: relative;
`;

export const MetricHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
`;

export const MetricTitle = styled.p`
  margin: 0;
  color: #0b1d5d;
  font-size: 14px;
  font-weight: 700;
  word-break: break-word;
  line-height: 1.25;
  max-width: 100%;
`;

export const MetricBadge = styled.span<{ $type?: string }>`
  padding: 5px 9px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  color: ${(props) => (props.$type === "Pacientes" ? "#0b5fff" : "#0f995c")};
  background: ${(props) =>
    props.$type === "Pacientes"
      ? "rgba(11,95,255,0.12)"
      : "rgba(15,153,92,0.12)"};
  border: 1px solid
    ${(props) => (props.$type === "Pacientes" ? "#c8d9ff" : "#c7eedc")};
  white-space: nowrap;
  flex-shrink: 0;
  align-self: flex-start;
`;

export const MetricValue = styled.p`
  margin: 4px 0 0;
  color: #0b1d5d;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.4px;
`;

export const MetricFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #5c6a92;
  font-size: 12px;
  font-weight: 600;
  margin-top: auto;
`;

export const GaugeGrid = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  justify-content: center;
  align-items: stretch;

  @media (max-width: 680px) {
    flex-wrap: wrap;
  }
`;

export const GaugeCard = styled.div`
  background: white;
  border: 1px solid #e6e9f5;
  border-radius: 14px;
  padding: 14px 16px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  box-shadow: 0 12px 28px rgba(11, 29, 93, 0.06);
  min-height: 260px;
  flex: 1 1 240px;
  max-width: 320px;

  @media (max-width: 1024px) {
    flex: 1 1 48%;
    max-width: 340px;
  }

  @media (max-width: 640px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

export const GaugeHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SubLabel = styled.p`
  margin: 4px 0 0;
  color: #5c6a92;
  font-size: 12px;
  font-weight: 600;
`;

export const StatusPill = styled.span<{ $tone?: "positive" | "neutral" | "alert" }>`
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 800;
  color: ${(props) =>
    props.$tone === "alert"
      ? "#c02e36"
      : props.$tone === "neutral"
      ? "#0b5fff"
      : "#0f995c"};
  background: ${(props) =>
    props.$tone === "alert"
      ? "rgba(192,46,54,0.12)"
      : props.$tone === "neutral"
      ? "rgba(11,95,255,0.12)"
      : "rgba(15,153,92,0.12)"};
  border: 1px solid
    ${(props) =>
      props.$tone === "alert"
        ? "#f7c5c8"
        : props.$tone === "neutral"
        ? "#c8d9ff"
        : "#c7eedc"};
  white-space: nowrap;
`;

export const GaugeValue = styled.p`
  margin: -4px 0 0;
  color: #0b1d5d;
  font-size: 34px;
  font-weight: 800;
  text-align: center;
`;

export const GaugeFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: auto;
  color: #5c6a92;
  font-size: 12px;
  font-weight: 600;
`;

export const ChartGrid = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  justify-content: center;
  align-items: stretch;

  @media (max-width: 680px) {
    flex-wrap: wrap;
  }
`;

export const ChartCard = styled.div<{ $fullWidth?: boolean }>`
  background: white;
  border: 1px solid #e6e9f5;
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: 0 12px 28px rgba(11, 29, 93, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-width: ${(props) => (props.$fullWidth ? "100%" : "420px")};
  flex: ${(props) => (props.$fullWidth ? "1 1 100%" : "1 1 340px")};

  @media (max-width: 1024px) {
    flex: ${(props) => (props.$fullWidth ? "1 1 100%" : "1 1 49%")};
    max-width: ${(props) => (props.$fullWidth ? "100%" : "360px")};
  }

  @media (max-width: 640px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

export const ChartCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const ChartTitle = styled.p`
  margin: 0;
  color: #0b1d5d;
  font-size: 16px;
  font-weight: 800;
`;

export const ChartDescription = styled.p`
  margin: 4px 0 0;
  color: #5c6a92;
  font-size: 13px;
  font-weight: 600;
`;

export const ChartBody = styled.div`
  margin-top: 8px;
  overflow: hidden;

  .recharts-legend-wrapper {
    padding-top: 10px;
    max-height: 100px;
    overflow: auto;
  }

  .recharts-legend-item {
    margin-bottom: 6px !important;
  }

  .recharts-legend-item-text {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #4c5f8f !important;
    word-break: break-word !important;
    white-space: normal !important;
  }
`;
